<script>
import appConfig from "@/app.config";
import LoginCab from "./login-cab.vue";
import LoginSop from "./login-sop.vue";
import LoginDemo from "./login-demo.vue";
import LoginOmn from "./login-omn.vue";
import LoginDist from "./login-dist.vue";
import LoginAvn from "./login-avn.vue";
import LoginMss from "./login-mss.vue";
import NotFoundPage from "@/router/views/utility/404.vue";

/**
 * Login component
 */
export default {
  page: {
    title: "Authentification",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {LoginCab, LoginSop, LoginOmn, LoginDist, LoginAvn, LoginMss, LoginDemo, NotFoundPage},

  computed:{
    selectedComponent() {
      switch (process.env.VUE_APP_CLIENT_NAME) {
        case "cab":
          return "LoginCab";
        case "sop":
          return "LoginSop";
        case "omn":
          return "LoginOmn";
        case "dist":
          return "LoginDist";
        case "avn":
          return "LoginAvn";
        case "mss":
          return "LoginMss";
        case "demo":
          return "LoginDemo";
        default:
          return "NotFoundPage"; 
      }
    }
  },
};
</script>


<template>
    <component :is="selectedComponent" />

</template>

